module.exports = __webpack_public_path__ + "img/40.8.TSS.f9a8d269.png";